/**
 * @generated SignedSource<<305d89e4975a254168696c582e5a3d7f>>
 * @relayHash b8f7201dedaae8bbc3ae18ef0fd52a7e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b315aa47f2f58b3f27b20a9456560c64af1a8dd08c654537378d1fc205bc4b65

import type { ConcreteRequest, Query } from 'relay-runtime';
export type CcpEntitlementPreDunningStatus = "IN_PRE_DUNNING" | "NOT_IN_PRE_DUNNING" | "%future added value";
export type ConfluenceFreePoolTargetExperimentAddtlEligibilityQuery$variables = {
  cloudId: string;
  productKey: string;
};
export type ConfluenceFreePoolTargetExperimentAddtlEligibilityQuery$data = {
  readonly tenantContexts: ReadonlyArray<{
    readonly entitlementInfo: {
      readonly entitlement: {
        readonly createdAt?: number | null | undefined;
        readonly experienceCapabilities: {
          readonly changeOfferingV2: {
            readonly experienceUrl: string | null | undefined;
            readonly isAvailableToUser: boolean | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly latestUsageForChargeElement: number | null | undefined;
        readonly preDunning: {
          readonly status: CcpEntitlementPreDunningStatus | null | undefined;
        } | null | undefined;
        readonly subscription: {
          readonly trial: {
            readonly timeLeft: number | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly transactionAccount: {
          readonly isBillToPresent: boolean | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined> | null | undefined;
};
export type ConfluenceFreePoolTargetExperimentAddtlEligibilityQuery = {
  response: ConfluenceFreePoolTargetExperimentAddtlEligibilityQuery$data;
  variables: ConfluenceFreePoolTargetExperimentAddtlEligibilityQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "productKey"
  }
],
v1 = [
  {
    "items": [
      {
        "kind": "Variable",
        "name": "cloudIds.0",
        "variableName": "cloudId"
      }
    ],
    "kind": "ListValue",
    "name": "cloudIds"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "hamsProductKey",
    "variableName": "productKey"
  }
],
v3 = {
  "args": [
    {
      "kind": "Literal",
      "name": "chargeElement",
      "value": "user"
    }
  ],
  "kind": "ScalarField",
  "name": "latestUsageForChargeElement",
  "storageKey": "latestUsageForChargeElement(chargeElement:\"user\")"
},
v4 = {
  "kind": "ScalarField",
  "name": "status"
},
v5 = {
  "kind": "ScalarField",
  "name": "isBillToPresent"
},
v6 = {
  "kind": "ScalarField",
  "name": "timeLeft"
},
v7 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "createdAt"
    }
  ],
  "type": "CcpEntitlement"
},
v8 = [
  {
    "kind": "Literal",
    "name": "offeringName",
    "value": "standard"
  }
],
v9 = {
  "kind": "ScalarField",
  "name": "isAvailableToUser"
},
v10 = {
  "kind": "ScalarField",
  "name": "experienceUrl"
},
v11 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v12 = {
  "kind": "ScalarField",
  "name": "id"
},
v13 = [
  (v12/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ConfluenceFreePoolTargetExperimentAddtlEligibilityQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "args": (v2/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "entitlement",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "preDunning",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "name": "transactionAccount",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "name": "subscription",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "trial",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v7/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "experienceCapabilities",
                    "plural": false,
                    "selections": [
                      {
                        "args": (v8/*: any*/),
                        "kind": "LinkedField",
                        "name": "changeOfferingV2",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          (v10/*: any*/)
                        ],
                        "storageKey": "changeOfferingV2(offeringName:\"standard\")"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ConfluenceFreePoolTargetExperimentAddtlEligibilityQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "args": (v2/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              (v11/*: any*/),
              {
                "kind": "LinkedField",
                "name": "entitlement",
                "plural": false,
                "selections": [
                  (v11/*: any*/),
                  (v3/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "preDunning",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/),
                      (v4/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "name": "transactionAccount",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/),
                      (v5/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": (v13/*: any*/),
                        "type": "Node",
                        "abstractKey": "__isNode"
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "name": "subscription",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "trial",
                        "plural": false,
                        "selections": [
                          (v11/*: any*/),
                          (v6/*: any*/)
                        ]
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v13/*: any*/),
                        "type": "CcpSubscription"
                      }
                    ]
                  },
                  (v7/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "experienceCapabilities",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/),
                      {
                        "args": (v8/*: any*/),
                        "kind": "LinkedField",
                        "name": "changeOfferingV2",
                        "plural": false,
                        "selections": [
                          (v11/*: any*/),
                          (v9/*: any*/),
                          (v10/*: any*/)
                        ],
                        "storageKey": "changeOfferingV2(offeringName:\"standard\")"
                      }
                    ]
                  },
                  (v12/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "b8f7201dedaae8bbc3ae18ef0fd52a7e",
    "id": "b315aa47f2f58b3f27b20a9456560c64af1a8dd08c654537378d1fc205bc4b65",
    "metadata": {},
    "name": "ConfluenceFreePoolTargetExperimentAddtlEligibilityQuery",
    "operationKind": "query",
    "text": "query ConfluenceFreePoolTargetExperimentAddtlEligibilityQuery($cloudId:ID!,$productKey:String!){tenantContexts(cloudIds:[$cloudId]){entitlementInfo(hamsProductKey:$productKey){__typename,entitlement{__typename,latestUsageForChargeElement(chargeElement:\"user\"),preDunning{__typename,status},transactionAccount{__typename,isBillToPresent,...on Node{__isNode:__typename,id}},subscription{__typename,trial{__typename,timeLeft},...on CcpSubscription{id}},...on CcpEntitlement{createdAt},experienceCapabilities{__typename,changeOfferingV2(offeringName:\"standard\"){__typename,isAvailableToUser,experienceUrl}},id}}}}"
  }
};
})();

(node as any).hash = "4095749cfc0289fbe8c9a1dab75c85a2";

export default node;
